import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";
import momentTimezone from 'moment-timezone';

moment.tz.setDefault("America/Sao_Paulo");

export function dateTimeFormat(dateTime) {
  return moment(dateTime).format('DD/MM/YY HH:mm');
}

export function dateFormat(dateTime) {
  return moment(dateTime).format('DD/MM/YY');
}
